const footerPopup = () => {
  // Select the elements
  const targetElement = document.querySelector(".footer__menu-links-wrapper");
  const popupElement = document.querySelector(".footer__popup");

  if (targetElement && popupElement) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
            // Add the class when in view or when scrolled below
            popupElement.classList.add("in-view");
          } else if (entry.boundingClientRect.top >= 0) {
            popupElement.classList.remove("in-view");
          }
        });
      },
      {
        threshold: [0], // Trigger when even 1 pixel is visible
      }
    );

    observer.observe(targetElement);
  }
};

if (document.readyState !== "loading") {
  footerPopup();
} else {
  document.addEventListener("DOMContentLoaded", footerPopup);
}
